import { IAppState } from '../types/redux';

export function selectIsAuthenticated(state: IAppState) {
  return state.authentication.isAuthenticated;
}
